export enum LocalizationItem {
  Category = 'Category',
  Hide = 'Hide',
  Home = 'Home',
  HiHowCanWeHelp = 'HiHowCanWeHelp',
  MostCommonQuestions = 'MostCommonQuestions',
  NResultsForQuery = 'NResultsForQuery',
  Search = 'Search',
  SearchInSupportCenter = 'SearchInSupportCenter',
  ShowMore = 'ShowMore',
  SupportCenter = 'SupportCenter',
}
